<template>
    <simple-flowchart :scene.sync="data"
                      :height="flowChartHeight"
                      @linkAdded="addDependency($event)"
                      @linkBreak="deleteDependency($event)"/>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      journeys: state => state.journey.journeys
    }),
    flowChartHeight () {
      console.log(this.$vuetify.breakpoint)
      const { xlOnly } = this.$vuetify.breakpoint
      return xlOnly ? 680 : 500
    }
  },
  created () {
    this.setFlowChart()
  },
  data () {
    return {
      data: {
        centerX: 1024,
        centerY: 140,
        scale: 1,
        nodes: [],
        links: []
      },
      isMoving: false
    }
  },
  methods: {
    async addDependency (link) {
      const { from, to } = link
      const journeyDependencies = this.journeys.find(item => item.id === to).dependsOn
      journeyDependencies.push(from)
      await this.$store.dispatch('updateDependsOn', { journeyId: to, dependsOn: journeyDependencies })
    },
    changeMovingStatus (e) {
      if (e.target.classList.contains('deletable-transparent-element')) return
      this.isMoving = true
    },
    async deleteDependency (link) {
      const { from, to } = link
      const journeyDependencies = this.journeys.find(item => item.id === to).dependsOn
      const dependencyToDeleteIndex = journeyDependencies.indexOf(from)
      journeyDependencies.splice(dependencyToDeleteIndex, 1)
      await this.$store.dispatch('updateDependsOn', { journeyId: to, dependsOn: journeyDependencies })
    },
    setCardsLinksColors () {
      const cards = document.getElementsByClassName('flowchart-node')
      Array.prototype.forEach.call(cards, card => {
        const deleteButton = card.children[3]
        const header = card.children[1].children[0]
        const description = card.children[1].children[1]
        const journey = this.journeys.find(item => item.name === header.innerHTML)
        if (journey) {
          card.style.boxShadow = `0 0 0 2px ${journey.mainColor}`
          header.style.background = journey.mainColor
          description.style.display = 'none'
          deleteButton.classList.add('red-delete-button')
          const clickableElementToDelete = document.createElement('DIV')
          clickableElementToDelete.classList.add('deletable-transparent-element')
          deleteButton.appendChild(clickableElementToDelete)
          deleteButton.children[0].addEventListener('click', () => this.deleteJourney(journey.id))
        }
      })
    },
    setFlowChart () {
      this.data.nodes = []
      this.data.links = []
      let linkIdCounter = 0
      for (const journeyCard of this.journeys) {
        this.data.nodes.push({
          id: journeyCard.id,
          x: journeyCard.template.x,
          y: journeyCard.template.y,
          type: journeyCard.name,
          label: journeyCard.template.description
        })
        for (const dependency of journeyCard.dependsOn) {
          if (typeof dependency === 'number') {
            this.data.links.push({
              id: linkIdCounter, // link id
              from: dependency, // link start node-id
              to: journeyCard.id // link end node-id
            })
            linkIdCounter += 1
          }
        }
      }
    },
    async saveCardPositionEvent (e, journeyId) {
      if (!this.isMoving) return
      try {
        const nodeId = [...this.data.nodes].map(item => item.id).indexOf(journeyId)
        const journey = this.journeys.find(item => item.id === journeyId)
        let { template, ...all } = journey
        if (nodeId !== -1 && journey) {
          template = this.data.nodes[nodeId]
          const data = { template, ...all }
          await this.$store.dispatch('updateJourney', { journeyId, data })
        }
        this.isMoving = false
      } catch (e) {
        this.isMoving = false
        throw e
      }
    },
    setSaveCardsPositionEvent () {
      const cards = document.getElementsByClassName('flowchart-node')
      let i = 0
      Array.prototype.forEach.call(cards, card => {
        const journeyId = this.journeys[i].id
        card.addEventListener('mousedown', e => this.changeMovingStatus(e))
        card.addEventListener('mouseup', e => this.saveCardPositionEvent(e, journeyId))
        i += 1
      })
    },
    deleteJourney (journeyId) {
      this.$emit('deleteJourney', journeyId)
    }
  },
  mounted () {
    this.setCardsLinksColors()
    this.setSaveCardsPositionEvent()
  },
  updated () {
    this.setCardsLinksColors()
    this.setSaveCardsPositionEvent()
  },
  watch: {
    journeys (newValue, oldValue) {
      this.setFlowChart()
      if (newValue.length >= oldValue.length) {
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style>
    .flowchart-container[data-v-8730bea4] {
        background: #F0F4FD!important;
    }
    .flowchart-node .node-main .node-type[data-v-67208d28] {
        background: #4279D6;
    }
    path[data-v-295297bd] {
        stroke: #4279D6!important;
    }
    .flowchart-node .node-delete[data-v-67208d28].red-delete-button {
      border: 1px solid red;
      color: red;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
      width: 20px;
      height: 20px;
      right: -12px;
      top: -12px;
      font-size: 16px;
    }
    .flowchart-node .node-delete[data-v-67208d28].red-delete-button:hover {
      background-color: red;
      color: white;
    }
    .flowchart-node .node-delete[data-v-67208d28] .deletable-transparent-element {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: transparent;
    }
</style>
